<template>
  <div class="org" v-if="infoData">
    <div class="header">
      <div class="back">
        <!-- <button @click="goback">
          <img class="btn" src="../assets/dp-btn.png" alt />
        </button> -->
        <span class="tips" @click="gotopage('home')">首页</span>
        <span class="tips" @click="gotopage('site')">区域</span>
      </div>
<!--      <div class="sdbi">-->
<!--        <button @click="openSdBi()">智能设备大屏</button>-->
<!--      </div>-->
      <div class="logo">
        <img src="../assets/logo.png" />
        <span>{{ titleName }}</span>
      </div>
      <div class="datetime">
        <el-select
          style="color: black"
          v-model="organization"
          placeholder=""
          @change="seleorganization"
        >
          <el-option
            v-for="item in menuData"
            :key="item.id"
            :label="item.branchName"
            :value="item.branchId"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="main">
      <div class="main-up">
        <div class="buildings" v-if="infoData.orgDetail">
          <div class="overview">
            <h4>项目概况</h4>
            <div class="nums">
              <ul>
                <li>
                  <span>{{ biFirstScreenType['BI_FIRST_SCREEN_BEDS'] }}</span>
                  <h2>{{ infoData.beds }}</h2>
                </li>
                <li>
                  <span>{{ biFirstScreenType['BI_FIRST_SCREEN_INTO_ELDERS'] }}</span>
                  <h2>{{ infoData.intoElders }}</h2>
                </li>
                <li>
                  <span>入住率</span>
                  <h2>
                    {{
                      infoData.intoElders === 0
                        ? 0
                        : Math.round(
                            parseFloat(infoData.intoElders / infoData.beds) * 100
                          )
                    }}%
                  </h2>
                </li>
                <li>
                  <span>工作人员(人)</span>
                  <h2>{{ infoData.serviceStaffs }}</h2>
                </li>
              </ul>
            </div>
          </div>
          <div class="building-image">
            <!-- <img src="../assets/org/org_building.jpg" alt="" /> -->
            <swiper
              class="swiper"
              :options="swiperOption"
              :auto-update="true"
              @slideChangeTransitionEnd="slideChanged"
            >
              <swiper-slide
                v-for="item in infoData.orgDetail.attachList"
                :key="item.id"
              >
                <img
                  :src="`/ophApi/commonAttachDown/download?id=${item.id}`"
                  alt=""
                />
              </swiper-slide>
              <!-- <div class="swiper-pagination swiper-pagination-bullets" slot="pagination"></div> -->
            </swiper>
          </div>
          <div class="bullets">
            <ul>
              <li
                v-for="(item, i) in infoData.orgDetail.attachList"
                :key="item.id"
                :class="{ on: swiperIndex === i }"
              >
                {{ item.fileDescription }}
              </li>
            </ul>
          </div>
        </div>
        <div class="nearby">
          <div class="block">
            <div class="block-header">
              <span>周边配套</span>
              <el-select
                v-if="zhandianoptions.length > 0"
                style="color: black;margin-top: -10px;margin-left: 40px;"
                v-model="zhandianId"
                placeholder=""
                @change="selezhandian"
              >
                <el-option
                  v-for="item in zhandianoptions"
                  :key="item.id"
                  :label="item.branchName"
                  :value="item.branchName"
                >
                </el-option>
              </el-select>
            </div>
            <div class="block-content">
              <!-- <div class="map-container" @click="godetail"> -->
              <div class="map-container">
                <div id="mapContainers"></div>
              </div>
              <div
                class="nearby-dscp"
                v-if="infoData.orgDetail"
                v-html="convertParagraph(infoData.orgDetail.orgPeriphery)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="main-down" v-if="infoData.orgDetail">
        <div class="org-info">
          <div class="block">
            <div class="block-header">机构简介</div>
            <div class="block-content">
              <div class="text" v-html="infoData.orgDetail.profile"></div>
              <div class="features">
                <span>项目特色：</span>
                <ul>
                  <li v-for="feature in currOrgFeatureList" :key="feature">
                    <div class="img-container">
                      <img
                        src="../assets/org/features/144001.png"
                        v-if="feature == 144001"
                        alt=""
                      />
                      <img
                        src="../assets/org/features/144002.png"
                        v-if="feature == 144002"
                        alt=""
                      />
                      <img
                        src="../assets/org/features/144003.png"
                        v-if="feature == 144003"
                        alt=""
                      />
                      <img
                        src="../assets/org/features/144004.png"
                        v-if="feature == 144004"
                        alt=""
                      />
                      <img
                        src="../assets/org/features/144005.png"
                        v-if="feature == 144005"
                        alt=""
                      />
                    </div>
                    <span>{{ getFeatureName(feature) }}</span>
                  </li>
                  <!-- <li>
                    <img src="../assets/org/hdff.png" alt="" />
                    <span>活动丰富</span>
                  </li>
                  <li>
                    <img src="../assets/org/hlsq.png" alt="" />
                    <span>活力社区</span>
                  </li>
                  <li>
                    <img src="../assets/org/tyssh.png" alt="" />
                    <span>田园式生活</span>
                  </li> -->
                </ul>
              </div>
              <div class="properties">
                <ul>
                  <li>
                    <img src="../assets/org/kysj.png" />&nbsp;开业时间：{{
                      moment(infoData.orgDetail.openDate).format("YYYY-MM-DD")
                    }}
                  </li>
                  <li>
                    <img src="../assets/org/xmgm.png" />&nbsp;项目规模：{{
                      infoData.orgDetail.scale
                    }}床位
                  </li>
                  <li>
                    <img src="../assets/org/dz.png" />&nbsp;地址：{{
                      infoData.orgDetail.addr
                    }}
                  </li>
                  <li>
                    <img src="../assets/org/dh.png" />&nbsp;电话：{{
                      infoData.orgDetail.phone
                    }}
                  </li>
                  <li>
                    <img
                      src="../assets/org/shuangrenjian.png"
                    />&nbsp;单人间：{{ infoData.orgDetail.singleRoom }}床
                  </li>
                  <li>
                    <img
                      src="../assets/org/shuangrenjian.png"
                    />&nbsp;双人间：{{ infoData.orgDetail.doubleRoom }}床
                  </li>
                  <li>
                    <img src="../assets/org/sanrenjian.png" />&nbsp;三人间：{{
                      infoData.orgDetail.tripleRoom
                    }}床
                  </li>
                  <li>
                    <img
                      src="../assets/org/shuangrenjian.png"
                    />&nbsp;其他房型：{{ infoData.orgDetail.otherRoom }}床
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="nurse-chart">
          <div class="block">
            <div class="block-header">护理等级分布</div>
            <div class="block-content">
              <div id="highchart-nurse"></div>
            </div>
          </div>
        </div>
        <div class="today-worker">
          <div class="block">
            <div class="block-header">今日值班人员</div>
            <div class="block-content">
              <ul>
                <li v-for="staff in infoData.staffList" :key="staff.id">
                  <div class="avatar">
                    <img
                      :src="`/ophApi/commonAttachDown/download?id=${staff.avatarId}`"
                    />
                  </div>
                  <div class="r">
                    <div class="worker-name">
                      <span>{{ staff.staffName }}</span
                      >{{ staff.post }}
                    </div>
                    <div>
                      {{ staff.staffIntroduce }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="monit">
          <div class="block">
            <div class="block-header">机构展示</div>
            <div class="block-content">
              <swiper
                class="swiper"
                :options="swiperOption"
              >
                <swiper-slide v-for="(group, i) in monitorList" :key="i">
                  <div class="screenshots">

                    <div
                      class="shot"
                      v-for="(monitor, j) in group"
                      :key="monitor.id"
                      @click="openMonitorModal(monitor.url)"
                    >
                      <video :id="`monitor-${i}-${j}`" muted></video>

                    </div>
                  </div>
                  <img style="width: 100%; height: 100%" :src="`/ophApi/commonAttachDown/download?id=${group.attachId}`" alt=""/>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>  -->
      </div>
    </div>
    <m-dialog
      :show.sync="monitorShow"
      :no-head="true"
      @open="monitorOpen"
      @close="monitorClose"
      :append-to-body="true"
      width="1000px"
    >
      <video id="monitor-modal" controls></video>
    </m-dialog>
  </div>
</template>
<script>
import Hls from 'hls.js'
import moment from 'moment'
import Highcharts from 'highcharts'
import Highcharts3d from 'highcharts/highcharts-3d'
import nurseChartOpts from '@/charts/nurse.js'
// import mapStyleJson from "./map-style-json.js";
import mapStyleJson from './custom_map_config.json'
import iconLocation from '../assets/org/icon_location.png'

Highcharts3d(Highcharts)

const featureMap = [
  { code: '144001', name: '临终关怀' },
  { code: '144002', name: '文娱活动丰富' },
  { code: '144003', name: '智能监控' },
  { code: '144004', name: '交通便利' },
  { code: '144005', name: '法国体系' }
]

// 监控轮播时长
const MONITOR_SLIDE_INTERVAL = 1000 * 60

export default {
  name: 'Org',
  data () {
    return {
      moment,
      featureMap,
      map: null,
      id: '',
      orgInfo: null,
      subOrgIndex: 0,

      currentTime: '',
      timer: null,
      swiperIndex: 0,

      player: null,
      monitorShow: false,
      monitorList: [], // 监控列表
      player2: null,
      $videoModal: null,
      hlsModalSrc: '', // 弹窗监控地址
      monitorRes: [],
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 2000
        }
      },
      city: '',
      insId: '',
      homeInfos: [],
      infoData: null,
      defaultProps1: {
        children: 'children',
        label: 'branchName'
      },
      menuData: [],
      organization: '',
      titleName: '',
      zhandianoptions: [],
      zhandianId: '',
      biFirstScreenType: {
        BI_FIRST_SCREEN_BRANCH_COUNT: '机构数(家)',
        BI_FIRST_SCREEN_BEDS: '总床位(床)',
        BI_FIRST_SCREEN_INTO_ELDERS: '在住床数(床)'
      }
    }
  },
  created () {
    this.city = this.$route.query.city * 1
    this.insId = this.$route.query.id * 1
    console.log(this.city, this.insId)
    this.getInfo()
  },
  mounted () {
    // 右上角时间
    this.startTimer()
    this.orgInfo = JSON.parse(localStorage.orgInfo)
    this.getBiFirstScreenType();
    this.$nextTick(async () => {
      this.map = new window.BMapGL.Map('mapContainers')
      this.map.setMapStyleV2({ styleJson: mapStyleJson })
      this.map.enableScrollWheelZoom(true)
      this.getloadata()
    })
  },
  methods: {
    getInfo () {
      var infoList = JSON.parse(localStorage.homeInfos)
      var city = this.city
      var insId = this.insId
      var array = infoList[city].children
      var infoData = infoList[city].children[insId]
      console.log(infoData, 'infoData')
      this.organization = infoData.branchId
      var data = []
      array.forEach((element, i) => {
        var object = {
          id: i,
          branchName: element.branchName,
          children: [],
          branchId: element.branchId,
          orgPropertyType: element.orgPropertyType
        }
        if (element.orgPropertyType != 1) { // 去除站点
          data.push(object)
        }
      })
      console.log(data)
      this.menuData = data
      this.infoData = infoData
    },
    // 右上角切换
    seleorganization (value) {
      this.infoData.branchId = value
      var infoList = JSON.parse(localStorage.homeInfos)
      infoList[this.city].children.forEach((item, index) => {
        if (item.branchId == value) {
          this.infoData = item
          this.insId = index
        }
      })
      this.getloadata()
    },
    // 切换站点
    selezhandian (val) {
      this.zhandianoptions.forEach((item, index) => {
        if (val == item.branchName) {
          this.$router.push({
            name: 'station',
            query: {
              info: JSON.stringify(item),
              city: this.city,
              insId: this.insId,
              orgId: this.infoData.branchId
            }
          })
        }
      })
    },
    // 左上角返回上一个页面
    gotopage (value) {
      console.log(value)
      this.$router.push({
        name: value,
        query: { city: this.city }
      })
    },
    slideChanged ($swiper) {
      this.swiperIndex = $swiper.activeIndex
    },
    async getloadata () {
      var i = 1
      // console.log(this.infoData.branchId);
      console.log(this.infoData, 'infoData')
      console.log(this.currOrg, 'currOrg')
      console.log(this.orgInfo, 'orgInfo')
      // 赋值站点
      const arr = this.infoData.children
      const arr1 = []
      arr.forEach((item, index) => {
        if (item.children.length > 0) {
          item.children.forEach(item1 => {
            arr1.push(item1)
          })
        }
      })
      this.zhandianoptions = arr1
      if (i) {
        const { data: res } = await this.$http({
          url: '/orgExtra/detail',
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          data: `id=${this.infoData.branchId}`
        })
        if (!res.data) {
          alert(res.msg)
        } else {
          this.titleName = res.data.name
          this.$set(
            this.infoData,
            'orgDetail',
            res.data
          )
        }
      }
      // 加载机构大屏数据
      if (i) {
        const { data: statsRes } = await this.$http.post(
          '/biDataDaily/typeBeanList',
          {
            branchId: this.infoData.branchId,
            initZero: true
          }
        )
        if (!statsRes.data) {
          alert(statsRes.msg)
        } else {
          this.$set(
            this.infoData,
            'orgStats',
            statsRes.data
          )
        }
      }
      // 加载今日值班人员
      if (i) {
        const { data: staffRes } = await this.$http.get(
          `/biServiceStaff/listBeans?branchId=${this.infoData.branchId}`
        )

        if (!staffRes.data) {
          alert(staffRes.msg)
        } else {
          this.$set(
            this.infoData,
            'staffList',
            staffRes.data.find((item) => item.staffType === 'DUTY_STAFF')
              .staffList
          )
        }
        // this.staffList = staffRes.data.find(item => item.staffType === 'DUTY_STAFF').staffList
      }
      if (i) {
        const that = this
        this.map.clearOverlays()
        this.infoData.nearbyPlaceList.forEach((e, i) => {
          var icons = require('../assets/site/yiyuan.png')
          var myIcon = new window.BMapGL.Icon(
            icons,
            new window.BMapGL.Size(32, 38), // 视窗大小
            {
              imageSize: new window.BMapGL.Size(32, 38), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new window.BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
          var content = e.placeName
          var pt = new window.BMapGL.Point(e.longitude, e.latitude)
          var label = new window.BMapGL.Label(content, {
            // 创建文本标注
            position: pt,
            offset: new window.BMapGL.Size(10, 20)
          })
          label.setStyle({
            // 设置label的样式
            color: '#fff',
            fontSize: '16px',
            border: '2px solid #1E90FF',
            backgroundColor: '#0066ff'
          })
          var maker = new window.BMapGL.Marker(pt, { icon: myIcon }) // 创建标注
          this.map.addOverlay(maker)
          this.map.addOverlay(label)
        })
        const point = new window.BMapGL.Point(
          this.infoData.orgDetail.longitude,
          this.infoData.orgDetail.latitude
        )
        this.map.centerAndZoom(point, 14)
        const icon = new window.BMapGL.Icon(
          iconLocation,
          new window.BMapGL.Size(60, 60),
          {
            // anchor: new BMapGL.Size(10, 25),
            // imageOffset: new window.BMapGL.Size(-15, -15)
          }
        )
        const marker = new window.BMapGL.Marker(point, { icon })
        marker.addEventListener('click', function () {
          if (that.infoData.children.length > 0 && that.infoData.orgPropertyType == 2) {
            sessionStorage.setItem('branchid', that.infoData.branchId)
            // console.log(that.insId, that.city);
            // that.$router.push("/area");
            that.$router.push(
              {
                name: 'area',
                query: {
                  insId: that.insId,
                  city: that.city,
                  orgId: that.infoData.branchId
                }
              })
          }
        })
        this.map.addOverlay(marker)
      }
      if (i) {
        Highcharts.chart(
          'highchart-nurse',
          nurseChartOpts(this.getChartInfo('BI_NURSE_LV_DIS'))
        )
      }
      // console.log(this.currOrg, "currOrg");
      // 监控列表
      const { data: monitorRes } = await this.$http.get(
        `/surveillancelist/SurveillancelistInfo?branchId=${this.currOrg.branchId}`
      )
      this.monitorRes = monitorRes.data
      const monitorGroupCount = Math.ceil(monitorRes.data.length / 1)
      const monitorGroups = []
      for (let i = 0; i < monitorGroupCount; i++) {
        if (i < monitorGroupCount - 1) {
          monitorGroups.push(monitorRes.data.slice(i, i + 1))
        } else {
          monitorGroups.push(
            monitorRes.data.slice(i, monitorRes.data.length + 1)
          )
        }
      }
      this.monitorList = monitorGroups

      this.$nextTick(() => {
        this.playMonitorGroup(0)
        this.monitorSwiperChanged()
      })
    },
    goback () {
      this.$router.go(-1)
    },
    getChartInfo (code) {
      return this.infoData.orgStats.find((item) => item.typeCode === code)
    },
    startTimer () {
      if (!this.timer) {
        this.timer = setInterval(() => {
          const now = moment()
          const datetime = now.format('YYYY-MM-DD HH:mm')
          const weekday = `星期${
            ['一', '二', '三', '四', '五', '六', '日'][now.isoWeekday() - 1]
          }`
          this.currentTime = `${datetime} ${weekday}`
        }, 1000)
      }
    },
    convertParagraph (str) {
      return str.replace(/\n/g, '<br>')
    },
    loadHls ($video, hlsSrc) {
      const hlsPlayer = new Hls({
        maxBufferSize: 1000 * 1000
      })
      hlsPlayer.loadSource(hlsSrc)
      hlsPlayer.attachMedia($video)
      hlsPlayer.on(Hls.Events.ERROR, (event, data) => {
        console.error(data)
      })
      return hlsPlayer
    },
    getFeatureName (code) {
      const feature = this.featureMap.find((o) => {
        return parseInt(o.code) === parseInt(code)
      })
      if (feature) {
        return feature.name
      } else {
        return ''
      }
    },
    playMonitorGroup (i) {
      if (this.monitorList[i]) {
        this.monitorList[i].forEach((monitor, j) => {
          if (monitor.player) {
            this.$el.querySelector(`#monitor-${i}-${j}`).play()
          } else {
            const hlsSrc = monitor.url
            const $video = this.$el.querySelector(`#monitor-${i}-${j}`)
            monitor.player = this.loadHls($video, hlsSrc)
            monitor.player.on(Hls.Events.MANIFEST_PARSED, () => {
              $video.play()
            })
          }
        })
      }
    },
    pauseMonitorGroup (i) {
      if (this.monitorList[i]) {
        this.monitorList[i].forEach((monitor, j) => {
          if (monitor.player) {
            this.$el.querySelector(`#monitor-${i}-${j}`).pause()
          }
        })
      }
    },
    monitorSwiperChanged ($swiper) {
      const index = $swiper ? $swiper.activeIndex : 0
      const lastIndex = this.monitorList.length - 1
      const prevIndex = index === 0 ? lastIndex : index - 1
      const nextIndex = index === lastIndex ? 0 : index + 1
      this.pauseMonitorGroup(prevIndex)
      setTimeout(() => {
        this.playMonitorGroup(nextIndex)
      }, Math.max(MONITOR_SLIDE_INTERVAL - 10000, 0))
    },
    openMonitorModal (hlsSrc) {
      this.hlsModalSrc = hlsSrc
      this.monitorShow = true
    },
    monitorOpen () {
      if (this.player2) {
        this.player2.destroy()
        this.player2 = null
      }
      this.$nextTick(() => {
        this.$videoModal = document.querySelector('#monitor-modal')
        this.player2 = this.loadHls(this.$videoModal, this.hlsModalSrc)
        this.player2.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$videoModal.play()
        })
      })
    },
    monitorClose () {
      this.$videoModal.pause()
    },
    async getBiFirstScreenType () {
      try {
        const formData = new FormData()
        formData.append('codeTypeId', 10087)
        const { data: res } = await this.$http.post('/comn/codeValue/list', formData)
        for (const row of res.data.rows) {
          this.biFirstScreenType[row.codeValue] = row.nameCn
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  beforeDestroy () {
    if (!this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.monitorList.forEach((group) => {
      group.forEach((monitor) => {
        if (monitor.player) {
          monitor.player.destroy()
        }
      })
    })
    if (this.player2) {
      this.player2.destroy()
    }
  },
  computed: {
    // currOrg() {
    //   return this.orgInfo ? this.orgInfo.children[this.subOrgIndex] : null;
    // },
    currOrgFeatureList () {
      if (
        this.currOrg &&
        this.currOrg.orgDetail &&
        this.currOrg.orgDetail.orgFeature
      ) {
        return this.currOrg.orgDetail.orgFeature
          .split(',')
          .map((str) => parseInt(str))
      } else {
        return []
      }
    },
    swiperOption () {
      return {
        pagination: {
          el: '.swiper-pagination',
          clickable: true /* ,
          renderBullet (index, className) {
            // return `<span class="${className} swiper-pagination-bullet-custom">${index + 1}</span>`
            if (this.currOrg && this.currOrg.orgDetail) {
              return `<span>${this.currOrg.orgDetail.attachList[index].fileDescription}</span>`
            } else {
              return ''
            }
          } */
        },
        autoplay: {
          delay: 5000
        }
      }
    },
    monitorSwiperOpts () {
      return {
        autoplay: {
          delay: MONITOR_SLIDE_INTERVAL
        },
        allowTouchMove: false
      }
    }
  }
}
</script>
<style lang="scss" scope>
.org {
  width: 1920px;
  height: 1080px;
  background: url("../assets/home/bg.jpg");
  // * {
  //   color: #fff;
  // }
  .header {
    width: 100%;
    height: 116px;
    background: url("../assets/home/logokuang.png") no-repeat;
    background-position: center bottom;
    display: flex;
    align-items: center;
    position: relative;
    // > div {
    //   width: 33.33%;
    // }
    .back {
      z-index: 2;
      text-align: left;
      box-sizing: border-box;
      // width: 300px;
      button {
        background: transparent;
        border: 0;
      }
    }
    .sdbi {
      text-align: left;
      line-height: 40px;
      padding-bottom: 20px;
      box-sizing: border-box;
      width: 200px;
      button {
        background: transparent;
        border: 0;
        font-size: 20px;
        color: #08fbfb;
        margin-top: 20px;
        font-family: "pangmenzhengdao";
        line-height: 40px;
        cursor: pointer;
      }
    }
    .logo {
      // background: url('../assets/org/logo.png') no-repeat;
      // background-position: center top 20px;
      width: 100%;
      line-height: 116px;
      font-size: 34px;
      color: #08fbfb;
      font-family: "pangmenzhengdao";
      position: absolute;
      top: 0;
      left: 0;
      img {
        width: 44px;
      }
      span {
        font-size: 40px;
        color: #08fbfb;
        margin-left: 12px;
        font-family: "pangmenzhengdao";
        letter-spacing: 4px;
        // max-width: 660px;
        line-height: 40px;
      }
    }
    .datetime {
      width: 255px;
      z-index: 2;
      margin-left: 15px;
      // padding-right: 24px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: center;
      span {
        color: #fff;
        font-size: 24px;
        font-weight: bold;
        line-height: 80px;
      }
      .switch {
        width: 190px;
        height: 32px;
        background-color: #154a93;
        border-radius: 50px;
        position: relative;
        display: flex;
        > div {
          width: 95px;
          height: 32px;
          background: url(../assets/org/switch.png) no-repeat;
          background-size: 12px 17px;
          background-position: center;
        }
        .prev {
          left: 50px;
        }
        .next {
          right: 50px;
          transform-origin: center;
          transform: rotate(180deg);
        }
        &::after {
          content: "";
          width: 1px;
          height: 32px;
          position: absolute;
          left: 95px;
          background-color: #0f328c;
        }
      }
    }
  }
  .main {
    padding: 0 24px;
    .main-up {
      height: 550px;
      display: flex;
      padding-top: 10px;
      box-sizing: border-box;
      color: #fff;
      .buildings {
        width: calc(50% - 10px);
        position: relative;
        .overview {
          position: absolute;
          top: -1px;
          width: 100%;
          background: linear-gradient(to bottom, #061259, rgba(6, 18, 89, 0));
          z-index: 9;
          h4 {
            text-align: left;
            font-size: 18px;
            font-weight: bold;
            padding: 5px;
            margin: 0;
            line-height: 30px;
          }
          .nums {
            ul {
              display: flex;
              padding: 0 50px;
              li {
                width: 33.33%;
                h2 {
                  font-size: 50px;
                  margin: 0;
                  line-height: 80px;
                }
                &:first-child h2 {
                  color: #f9f404;
                }
                &:nth-child(2) h2 {
                  // color: #4ee699;
                  color: #f9f404;
                }
                &:nth-child(3) h2 {
                  // color: #c955f4;
                  color: #f9f404;
                }
                &:nth-child(4) h2 {
                  // color: #0696ef;
                  color: #f9f404;
                }
              }
            }
          }
        }
        .building-image {
          height: 100%;
          overflow: hidden;
          .swiper-container {
            width: 100%;
            height: 100%;
            .swiper-slide img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .bullets {
          position: absolute;
          bottom: -1px;
          width: 100%;
          background: linear-gradient(to top, #061259, rgba(6, 18, 89, 0));
          z-index: 9;
          ul {
            display: flex;
            justify-content: center;
            li {
              width: 100px;
              height: 40px;
              line-height: 40px;
              text-align: center;
              color: #0ab2f3;
              cursor: pointer;
              &.on {
                background-color: #143185;
                color: #fff;
              }
            }
          }
        }
      }
      .nearby {
        width: calc(50% - 10px);
        margin-left: 20px;
        .block {
          background-color: transparent;
          height: 100%;
        }
        .block-header {
          font-size: 18px;
        }
        .block-content {
          display: flex;
          height: 505px;
          > div {
            width: calc(50% - 10px);
          }
          .map-container {
            height: 100%;
            #mapContainers {
              width: 100%;
              height: 100%;
            }
          }
          .nearby-dscp {
            margin-left: 40px;
            text-align: left;
            font-size: 18px;
            overflow: hidden;
          }
        }
      }
    }
    .main-down {
      margin-top: 20px;
      display: flex;
      height: 370px;
      color: #fff;
      .org-info {
        width: calc(50% - 10px);
        .block-content {
          .text {
            text-align: left;
            border-bottom: 1px solid #153faa;
            padding: 10px 0;
            height: 130px;
            overflow: hidden;
            box-sizing: border-box;
          }
          .features {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px solid #153faa;
            height: 72px;
            box-sizing: border-box;
            ul {
              display: flex;
              li {
                text-align: center;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-between;
                margin-right: 20px;
                font-size: 14px;
                .img-container {
                  height: 28px;
                  line-height: 28px;
                  img {
                    height: 80%;
                    width: auto;
                  }
                }
                span {
                  margin-left: 5px;
                }
              }
            }
          }
          .properties {
            padding: 10px 0;
            ul {
              display: flex;
              flex-wrap: wrap;
              li {
                width: 50%;
                text-align: left;
                display: flex;
                align-items: center;
                line-height: 30px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                img {
                  margin-right: 5px;
                }
              }
            }
          }
        }
      }
      .nurse-chart,
      .today-worker,
      .monit {
        width: calc(33.33% - 6.66px);
        margin-left: 10px;
      }
      .nurse-chart {
        .block {
          height: 100%;
          #highchart-nurse {
            height: 100%;
          }
        }
      }
      .today-worker {
        .block {
          height: 100%;
        }
        .block-content {
          display: flex;
          align-items: center;
          li {
            display: flex;
            align-items: center;
            .avatar {
              width: 100px;
              overflow: hidden;
              img {
                width: 100%;
                height: auto;
              }
            }
          }
          .r {
            text-align: left;
            padding: 10px;
            flex: 1;
            span {
              font-size: 18px;
              color: #36c4ff;
              margin-right: 5px;
            }
          }
        }
      }
      .monit {
        .block {
          height: 100%;
          .block-content {
            padding: 10px;
            display: flex;
            align-items: center;
            .swiper-container {
              margin: 0;
              .swiper-slide {
                width: 100% !important;
              }
            }
            .shot {
              width: 100%;
              height: 100%;
              position: relative;
              .address {
                position: absolute;
                top: 10px;
                left: 10px;
              }
              .area {
                position: absolute;
                width: 100%;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                font-weight: bold;
                text-align: center;
                background-color: rgb(0, 90, 255, 0.5);
                bottom: 0;
              }
              img,
              video {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
  }

  .block {
    background-color: rgb(0, 90, 255, 0.3);
    display: flex;
    flex-direction: column;
    height: 100%;
    .block-header {
      display: flex;
      font-size: 14px;
      font-weight: bold;
      // justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      height: 35px;
      line-height: 35px;
    }
    .block-content {
      padding: 0 10px 10px 10px;
      flex: 1;
    }
  }

  ul,
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
}
#monitor-modal {
  width: 100%;
  height: auto;
}
.menu {
  position: absolute;
  right: 115px;
  background-color: #06156100;
  width: 300px;
  font-size: 14px;
}

.el-tree-node__content:hover {
  background-color: #06156100 !important;
}
.el-tree-node:focus > .el-tree-node__content {
  background-color: #06156100 !important;
}
.selecr {
  color: black !important;
}
.tips {
  font-size: 30px;
  cursor: pointer;
  color: aqua;
  margin-left: 20px;
}
.el-select .el-input .el-select__caret {
  color: #c0c4cc00;
}
.el-input__inner {
  background-color: #fff0;
  color: #08fbfb;
  border: 1px solid #08fbfb;
  font-size: 24px;
}
</style>
